export default {
  readMore: 'Read more',
  fullText: 'Full text',
};
